import { joinUrlPath } from '@/utils/common';
import { apiPrefix } from '@/config/base';
import { apiRequest } from '@/utils/request';

export function funnelGetQueryId({ data = {} }) {
  return apiRequest({
    method: 'post',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/funnel/get-query-id'),
    data,
    restful: true,
  });
}

export function funnelPollingData({ params = {} }) {
  return apiRequest({
    method: 'get',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/funnel/polling-data'),
    params,
    restful: true,
  });
}

export function ltvGetQueryId({ data = {} }) {
  return apiRequest({
    method: 'post',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/get-data/ltv'),
    data,
    restful: false,
  });
}

export function ltvPollingData({ params = {} }) {
  return apiRequest({
    method: 'get',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/polling-data'),
    params,
    restful: false,
  });
}

export function thermalGetQueryId({ data = {} }) {
  return apiRequest({
    method: 'post',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/get-data/thermal'),
    data,
    restful: false,
  });
}

export function thermalPollingData({ params = {} }) {
  return apiRequest({
    method: 'get',
    url: joinUrlPath(apiPrefix, '/tmc-dap-metadata-api/v1/polling-data'),
    params,
    restful: false,
  });
}
